<div class="listing-card" 
     (click)="onCardClick()" 
     (mouseenter)="onMouseEnter()" 
     (mouseleave)="onMouseLeave()">
  <div class="card-image-container">
    <!-- Image carousel implementation -->
    <div class="carousel-container">
      <div class="carousel-images">
        <img *ngFor="let image of listing.images; let i = index" 
             [src]="formatImageUrl(image)" 
             class="card-image" 
             alt="{{listing.title}} - Image {{i+1}}"
             [class.active]="currentImageIndex === i">
      </div>
      
      <!-- Previous button on left -->
      <button class="carousel-control prev" 
              (click)="prevImage(); $event.stopPropagation()" 
              *ngIf="listing.images?.length > 1">
        <span class="control-icon">&#10094;</span>
      </button>
      
      <!-- Next button on right -->
      <button class="carousel-control next" 
              (click)="nextImage(); $event.stopPropagation()" 
              *ngIf="listing.images?.length > 1">
        <span class="control-icon">&#10095;</span>
      </button>
      
      <!-- Image indicators -->
      <div class="carousel-indicators" *ngIf="listing.images?.length > 1" (click)="$event.stopPropagation()">
        <span *ngFor="let image of listing.images; let i = index" 
              class="indicator" 
              [class.active]="currentImageIndex === i"
              (click)="setCurrentImage(i)"></span>
      </div>
    </div>
    
    <div class="offer-badge" *ngIf="listing.offerDesc && !listing.soldOut">{{listing.offerDesc}}</div>
    <div class="offer-badge" *ngIf="listing.soldOut">Leased - N/A</div>
    
  </div>

  <div class="card-content">
    <h3 class="card-title">{{listing.title}}</h3>
    <div class="card-details">
      <span class="listing-id">Listing # {{listing.listingId}}</span>
      <span class="acres-info">{{listing.acres}} Acres</span>
    </div>
    
    <!-- Added description here for better mobile visibility -->
    <div class="card-description" *ngIf="offerDesc">
      <p [innerHTML]="offerDesc | safeHtml"></p>
    </div>
    
    <div class="activities-container">
      <span *ngFor="let a of listing.activities" class="activity-icon-wrapper">
        <img [src]="formatActivityImg(a)" class="activity-icon" [title]="a.name" alt="{{a.name}}"/>
      </span>
    </div>
  </div>
</div>
